enum CargoUnit {
  Tons = "MT",
  Unit = "UNITS",
  m3 = "CBM",
  Barrels = "BARRELS",
}

export default CargoUnit;